import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import translate from '../translate';
import Navbar from '../navigation/navbar';
import LeftSide from '../main/left-side';
import VerticalNavigation from '../navigation/vertical-navigation';
import UsageDataSubscriptionConfigurationForm from './usage-data-subscription-configuration-form';
import EditLargeCard from '../main/edit-large-card';
import {
    LoadUsageDataSubscription,
    LoadUsagePeriods,
    StoreUsageDataSubscription,
} from '../../store/usageDataSlice';
import {
    REQUEST_FAILURE,
    REQUEST_INITIAL,
    REQUEST_PENDING,
    REQUEST_SUCCESS,
} from '../../store/network/managedRequest';
import UsagePeriodsCard from './usage-overview-card';
import memoize from 'memoize-one';
import { usingFeatureWriteAccess } from '../../util/usingFeatureAccess';
import { PbRequest } from '../../store/pbRequest';

const POSSIBLE_STATUSES = [
    REQUEST_INITIAL,
    REQUEST_PENDING,
    REQUEST_SUCCESS,
    REQUEST_FAILURE,
];

class PartnerUsageData extends React.Component {
    static propTypes = {
        strings: PropTypes.shape({
            listTitle: PropTypes.string,
            configurationTitle: PropTypes.string,
        }).isRequired,
        configuration: PropTypes.shape({}).isRequired,
        updateConfigurationRequest: PropTypes.shape({
            status: PropTypes.oneOf(POSSIBLE_STATUSES),
        }).isRequired,
        LoadUsageDataSubscription: PropTypes.func.isRequired,
        StoreUsageDataSubscription: PropTypes.func.isRequired,
        LoadUsagePeriods: PropTypes.func.isRequired,
        usageRequestStatus: PropTypes.oneOf(POSSIBLE_STATUSES).isRequired,
        usageByYearMonth: PropTypes.object.isRequired,
        selectedPartner: PropTypes.shape({}),
    };

    state = {
        configuration: undefined,
    };

    componentDidMount() {
        this.props.LoadUsageDataSubscription();
        this.props.LoadUsagePeriods();
    }

    getConfiguration = () => {
        return (
            (this.state.configuration === undefined
                ? this.props.configuration
                : this.state.configuration) || {}
        );
    };

    _handleConfigurationChange = (newData) => {
        this.setState({ configuration: newData.configuration });
    };

    _handleConfigurationCancel = () => {
        this.setState({ configuration: undefined });
    };

    _handleConfigurationSubmit = ({ _valid, configuration }) => {
        if (_valid) {
            this.props.StoreUsageDataSubscription(configuration);
        }
    };

    _hasWriteAccess = memoize((selectedPartner) => {
        return usingFeatureWriteAccess(selectedPartner, 'ACCOUNTING_NUMBERS');
    });

    render() {
        return (
            <Navbar nav>
                <Row>
                    <LeftSide>
                        <VerticalNavigation selected="usage-data" />
                    </LeftSide>
                    <Col xs={6} className={'col-middle'}>
                        <UsagePeriodsCard
                            loading={
                                this.props.usageRequestStatus ===
                                REQUEST_PENDING
                            }
                            data={this.props.usageByYearMonth}
                        />

                        <EditLargeCard
                            type={'card-edit'}
                            title={this.props.strings.configurationTitle}
                            handleCancel={() =>
                                this._handleConfigurationCancel()
                            }
                            handleSubmit={(data) =>
                                this._handleConfigurationSubmit(data)
                            }
                            error={
                                this.props.updateConfigurationRequest.status ===
                                REQUEST_FAILURE
                            }
                            disabled={
                                !this._hasWriteAccess(
                                    this.props.selectedPartner
                                )
                            }
                        >
                            <UsageDataSubscriptionConfigurationForm
                                configuration={this.getConfiguration()}
                                handleChange={(newData) =>
                                    this._handleConfigurationChange(newData)
                                }
                            />
                        </EditLargeCard>
                    </Col>
                    <Col xs={4} />
                </Row>
            </Navbar>
        );
    }
}

export default connect(
    (store) => ({
        configuration: store.usageData.usageDataSubscription || {},
        updateConfigurationRequest:
            store.pbRequest[PbRequest.PUT_USAGE_DATA_SUBSCRIPTION],
        usageRequestStatus: store.pbRequest[PbRequest.GET_USAGE_PERIODS].status,
        usageByYearMonth: store.usageData.usageByYearMonth,
        selectedPartner: store.partnerManager.selectedPartner,
    }),
    { LoadUsageDataSubscription, StoreUsageDataSubscription, LoadUsagePeriods }
)(translate('PartnerUsageData')(PartnerUsageData));
